export default "__VITE_ASSET__CZQlweOe__"